import SensorErrorService from "@/service/SensorErrorService";

const initialState = {
    sensorErrors: [],
    tableOptions: null,
    searchString: '',
    queryStatus: 'all',
    loading: false,
    count: 0,
    activeProbeErrors: [],
    activeProbeSensors: []
}

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        async fetchAllSensorErrors({commit, state}) {
            let params = {
                search: state.searchString,
                page: state.tableOptions && state.tableOptions.page ? state.tableOptions.page : 1,
                itemsPerPage: state.tableOptions && state.tableOptions.itemsPerPage ? state.tableOptions.itemsPerPage : 20,
                status: state.queryStatus ? state.queryStatus : null,
            };
            try {
                commit('setSensorErrors', [])
                commit('setLoading', true)
                const resp = await SensorErrorService.getAllErrors(params)
                commit('setSensorErrors', resp?.data?.errors)
                commit('setCount', resp?.data?.count)
                commit('setLoading', false)
            } catch (e) {
                console.error(e)
                commit('setLoading', false)
            }
        },
        async fetchProbeErrors({commit, state}, payload) {
            const {probeId, sensorId} = payload
            let params = {
                probeId,
                sensorId,
                page: state.tableOptions && state.tableOptions.page ? state.tableOptions.page : 1,
                itemsPerPage: state.tableOptions && state.tableOptions.itemsPerPage ? state.tableOptions.itemsPerPage : 20,
            };
            try {
                commit('setLoading', true)
                const resp = await SensorErrorService.getProbeErrors(params)
                if (resp?.data?.errors) commit('setActiveProbeErrors', resp.data.errors)
                if (resp?.data?.probe_sensors) commit('setActiveProbeSensors', resp.data.probe_sensors)
                commit('setCount', resp?.data?.count)
                commit('setLoading', false)
            }
             catch (e) {
                console.error(e)
                commit('setLoading', false)
            }
        },
        async setShowErrorToUser({commit, dispatch}, payload) {
            const {probeId, value} = payload
            try {
                commit('setLoading', true)
                const resp = await SensorErrorService.setShowErrorToUser(probeId, value)
                if (resp.status === 204) {
                    await dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Show error to users updated',
                        type: 'success'
                    }, {root: true})
                    commit('updateProbeShowErrorToUser', {probeId, value})
                } else {
                    await dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Update failed!',
                        type: 'error'
                    }, {root: true})
                }
                commit('setLoading', false)
            }
            catch (e) {
                console.error(e)
                commit('setLoading', false)
            }
        }
    },
    mutations: {
        setSensorErrors(state, data) {
            state.sensorErrors = data
        },
        setTableOptions(state, data) {
            state.tableOptions = data
        },
        setSearchString(state, data) {
            state.searchString = data
        },
        setQueryStatus(state, data) {
            state.queryStatus = data
        },
        setLoading(state, data) {
            state.loading = data
        },
        setCount(state, data) {
            state.count = data
        },
        setActiveProbeErrors(state, data) {
            state.activeProbeErrors = data
        },
        setActiveProbeSensors(state, data) {
            state.activeProbeSensors = data
        },
        updateProbeShowErrorToUser(state, data) {
            const {probeId, value} = data
            const errorsToUpdate = state.sensorErrors.filter(error => error.station_id === probeId)
            const otherErrors = state.sensorErrors.filter(error => !errorsToUpdate?.includes(error))
            if (errorsToUpdate) {
                errorsToUpdate.forEach(error => {
                    error.show_error_to_user = value
                })
            }
            state.sensorErrors = [...errorsToUpdate, ...otherErrors]
        }
    }
}